import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "table-component" }
const _hoisted_2 = {
  key: 0,
  style: { minWidth: '32px' }
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "table-component__body" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["href", "target", "rel"]
const _hoisted_9 = {
  key: 0,
  class: "table-component__loader"
}
const _hoisted_10 = {
  class: "table-component__loader-cell",
  colspan: "7"
}
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = ["colspan"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableSortableHeader = _resolveComponent("TableSortableHeader")!
  const _component_IconComponent = _resolveComponent("IconComponent")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_PaginationRedesigned = _resolveComponent("PaginationRedesigned")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(['table-vertical-line', 'table-component__wrapper', _ctx.tableClass])
    }, [
      _createElementVNode("table", {
        class: _normalizeClass({
          'table-component__table_loading': _ctx.isLoading,
          'table-component__table_numeration': _ctx.isShowNumberColumn,
          'table-component__table_events': _ctx.getEventIconsConfigs?.length,
        })
      }, [
        _createElementVNode("colgroup", null, [
          (_ctx.isShowNumberColumn)
            ? (_openBlock(), _createElementBlock("col", _hoisted_2))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getEventIconsConfigs, (eventConfig) => {
            return (_openBlock(), _createElementBlock("col", {
              key: eventConfig.type,
              style: { minWidth: '28px' }
            }))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
            return (_openBlock(), _createElementBlock("col", {
              key: column.field,
              style: _normalizeStyle(_ctx.getThWidth(column))
            }, null, 4))
          }), 128))
        ]),
        _createVNode(_component_TableSortableHeader, {
          columns: _ctx.columns,
          sort: _ctx.sortValue,
          onSortChange: _ctx.onSortChange
        }, {
          leading: _withCtx(() => [
            (_ctx.isShowNumberColumn)
              ? (_openBlock(), _createElementBlock("th", _hoisted_3))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getEventIconsConfigs, (eventConfig) => {
              return (_openBlock(), _createElementBlock("th", {
                key: eventConfig.type
              }))
            }), 128))
          ]),
          _: 1
        }, 8, ["columns", "sort", "onSortChange"]),
        _createElementVNode("tbody", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getPreparedData, (item, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: item.id,
              onClick: ($event: any) => (_ctx.handleRowClick(item)),
              class: _normalizeClass([{ 'table-component__tr_clickable': _ctx.isRowClickable }, _ctx.getRowClass(index)])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getEventIconsConfigs, (eventConfig) => {
                return (_openBlock(), _createElementBlock("td", {
                  key: eventConfig.type,
                  class: "table-component__event-icon-wrapper"
                }, [
                  _createElementVNode("button", {
                    class: "table-component__event-icon-button",
                    onClick: ($event: any) => (eventConfig.func(item, _ctx.resetPagination))
                  }, [
                    _createVNode(_component_IconComponent, {
                      class: "table-component__event-icon icon--full-svg",
                      name: _ctx.getEventIconsNamesMap[eventConfig.type]
                    }, null, 8, ["name"])
                  ], 8, _hoisted_6)
                ]))
              }), 128)),
              (_ctx.isShowNumberColumn)
                ? (_openBlock(), _createElementBlock("td", _hoisted_7, [
                    _createTextVNode(_toDisplayString(_ctx.getMeta.firstItemNumber + index), 1),
                    _renderSlot(_ctx.$slots, "numberSuffix", {
                      row: _ctx.getItems[index]
                    }, undefined, true)
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
                return (_openBlock(), _createElementBlock("td", {
                  key: column.field,
                  style: _normalizeStyle({ textAlign: column.textAlign })
                }, [
                  (column.renderComponent)
                    ? (_openBlock(), _createBlock(_resolveDynamicComponent(column.renderComponent.component), _mergeProps({
                        key: 0,
                        ref_for: true
                      }, _ctx.getRenderComponentProps(column, item, index), {
                        row: item,
                        index: index
                      }), null, 16, ["row", "index"]))
                    : (column.link && column.link.callback(item) && !_ctx.isAbsoluteUrl(column.link.callback(item)))
                      ? (_openBlock(), _createBlock(_component_RouterLink, {
                          key: 1,
                          to: column.link.callback(item),
                          target: column.link.isBlank ? '_blank' : ''
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item[column.field]), 1)
                          ]),
                          _: 2
                        }, 1032, ["to", "target"]))
                      : (column.link && column.link.callback(item) && _ctx.isAbsoluteUrl(column.link.callback(item)))
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 2,
                            href: column.link.callback(item),
                            target: column.link.isBlank ? '_blank' : '',
                            rel: column.link.isBlank ? 'noopener noreferrer' : ''
                          }, _toDisplayString(item[column.field]), 9, _hoisted_8))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                            _createTextVNode(_toDisplayString(item[column.field]), 1)
                          ], 64))
                ], 4))
              }), 128))
            ], 10, _hoisted_5))
          }), 128)),
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                _createElementVNode("td", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_Loader)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.getIsEmpty)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                _createElementVNode("td", {
                  class: "text-center",
                  colspan: _ctx.getEmptyCellColspan
                }, _toDisplayString(_ctx.emptyText), 9, _hoisted_13)
              ]))
            : _createCommentVNode("", true)
        ])
      ], 2)
    ], 2),
    (_ctx.isShowPagination)
      ? (_openBlock(), _createBlock(_component_PaginationRedesigned, {
          key: 0,
          pageCount: _ctx.getMeta.pagesTotal,
          currentPage: _ctx.getMeta.pageNumber,
          loadingMore: _ctx.isLoadingMore,
          onChange: _ctx.onPageChange,
          onMore: _ctx.onPageMore
        }, null, 8, ["pageCount", "currentPage", "loadingMore", "onChange", "onMore"]))
      : _createCommentVNode("", true)
  ]))
}